import ResourceValueType from "components/core/ResourceValueType";
import dayjs from "dayjs";
import styled from "styled-components";
import { TDetailItem } from "./TableDetail";
import { useTranslation } from "react-i18next";

const TableDetailItem = ({
  type,
  energy,
  timeFrom,
  timeTo,
  price,
  trxPaid,
}: TDetailItem) => {
  const { t } = useTranslation();
  return (
    <Wrap>
      <td>
        <p className="size-1 color-white">{t(type)}</p>
      </td>
      <td>
        <ResourceValueType value={energy} typeFormatValue="0,0" />
      </td>

      <td>
        <p className="size-1 color-white nowrap">
          {dayjs(timeFrom).format("YYYY-MM-DD HH:mm")}
        </p>
      </td>
      <td>
        <p className="size-1 color-white nowrap">
          {dayjs(timeTo).format("YYYY-MM-DD HH:mm")}
        </p>
      </td>
      <td>
        <p className="size-1 color-white">{price}</p>
      </td>
      <td>
        <ResourceValueType value={trxPaid} type="TRX" />
      </td>
    </Wrap>
  );
};

export default TableDetailItem;
const Wrap = styled.tr`
  position: relative;
  &.show {
    height: 230px;
  }
  .tei-check {
    width: 20px;
    height: 20px;
    border: 1px solid var(--grey-400);
    cursor: pointer;
    position: relative;
    border-radius: 2px;
    &--checked {
      border: 1px solid var(--primary-green-400);
      background-color: var(--primary-green-400);
    }
    &__icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      svg {
        display: inline-flex;
      }
    }
  }
  .tei-detail {
    /* max-width: 60px; */
    button {
      min-width: 120px;
      padding: 4px 12px;
    }
  }
  .tei-price {
    display: flex;
    align-items: center;
    gap: 10px;
    .underline {
      text-decoration: line-through;
      color: var(--grey-600);
    }
  }
`;
